<template>
    <div>
        <Backer />
        <div class="fm-container">
            <div>
                <b-card-group deck>
                    <b-card
                        border-variant="primary"
                        header="Sales"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                    >
                        <!-- <b-card-text>
                            <b-button variant="primary" v-on:click="$router.push('/sales/new/')">
                                New Sale
                            </b-button>
                        </b-card-text>

                        <b-card-text>
                            <b-button variant="dark" v-on:click="$router.push('/sales/list/')">
                                View Sales
                            </b-button>
                        </b-card-text> -->

                        <b-card-text>
                            <b-button variant="dark" v-on:click="$router.push('/sales/')">
                                Sales
                            </b-button>
                        </b-card-text>
                    </b-card>
                </b-card-group>
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    export default {
        name: "ManageSales",
        components: {Backer},
        data: function(){
            return {

            }
        },
        methods: {},
        created: function(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManageSales.vue